import clsx from "clsx";
import { IconType } from "react-icons/lib";
import { MdKeyboardArrowDown } from "react-icons/md";

const InstructionsStep = (props: {
  children?: React.ReactNode;
  number?: number;
}) => {
  return (
    <div className="flex gap-3 items-center">
      <div className="flex justify-center items-center w-6 h-6 bg-white rounded-full border border-gray-200">
        <small className="text-sm font-bold text-gray-700">
          {props.number ?? "?"}
        </small>
      </div>
      <span className="text-gray-700">{props.children}</span>
    </div>
  );
};

const InstructionsSteps = (props: { steps: React.ReactNode[] }) => {
  return (
    <div className="px-4 space-y-6">
      <div className="space-y-4">
        {props.steps.map((step, index) => (
          <InstructionsStep key={index} number={index + 1}>
            {step}
          </InstructionsStep>
        ))}
      </div>
    </div>
  );
};

const InstructionsContainer = (props: {
  children?: React.ReactNode;
  hidden?: boolean;
}) => {
  return (
    <section
      className={clsx(
        "overflow-hidden bg-gray-50 rounded-lg transition-all ease-in-out duration-1000",
        {
          "max-h-screen p-4": !props.hidden,
          "max-h-0 opacity-40": props.hidden,
        },
      )}
    >
      {props.children}
    </section>
  );
};

const InstructionsHeader = ({
  title,
  icon: Icon,
}: {
  title: string;
  icon?: IconType;
}) => {
  return (
    <div className="flex justify-between items-center px-4 py-2 mb-6 bg-white rounded-xl border-2 border-gray-100 cursor-pointer">
      <div className="flex gap-3 items-center">
        {Icon && (
          <div className="flex justify-center items-center w-6 h-6 rounded">
            <Icon className="w-5 h-5 text-gray-800" />
          </div>
        )}
        <h2 className="text-lg font-semibold text-gray-800">{title}</h2>
      </div>
      <button className="text-gray-600 transition-colors hover:text-gray-800">
        <MdKeyboardArrowDown />
      </button>
    </div>
  );
};

export type InstructionsProps = {
  title: string;
  steps: React.ReactNode[];
  icon?: IconType;
  children?: React.ReactNode;
  hidden?: boolean;
};

export const Instructions = (props: InstructionsProps) => {
  return (
    <div className="p-6 mt-6 space-y-2 shadow-sm">
      <InstructionsContainer hidden={props.hidden}>
        <InstructionsHeader title={props.title} icon={props.icon} />
        <InstructionsSteps steps={props.steps} />
      </InstructionsContainer>
      {props.children}
    </div>
  );
};
